import { initUntypeable } from "untypeable";

export const u = initUntypeable();
